import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/pop.jpeg'

const _withId = /*#__PURE__*/_withScopeId("data-v-60447a06")

_pushScopeId("data-v-60447a06")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "banner",
  draggable: "false"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["pop-modal", { closing: _ctx.isClosing }]
      }, [
        _createVNode("div", {
          class: ["pop-modal-content", { closing: _ctx.isClosing }]
        }, [
          _createVNode("div", {
            class: ["pop-image", { 'is-mobile': _ctx.device.display === 1 }]
          }, [
            _hoisted_1,
            _createVNode("div", {
              class: "btn-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
            }, "×")
          ], 2)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
})